import React from 'react';
import useReveal from '../hooks/useReveal';

// Thin wrapper that toggles the .reveal / .is-visible classes on a
// container as it scrolls into view. Use for any "fade up on scroll"
// effect across the site:
//   <Reveal><MyCard /></Reveal>
// Optional `as` prop renders a different element (default: div).
// Optional `delay` (ms) staggers the animation — useful when revealing
// a row of cards that should cascade in.
export default function Reveal({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal${visible ? ' is-visible' : ''} ${className}`.trim()}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
